import { Currency } from '../types/currency';

export function parseCurrencyOptions(
  raw: string | undefined,
  allCurrencies: Currency[]
): Currency[] | null {
  if (!raw) return null;
  const match = raw.match(/^\[(.+)]$/);
  if (!match) return null;
  const codes = match[1].split(',').map(s => s.trim().toUpperCase());
  const valid = codes.filter(c =>
    allCurrencies.includes(c as Currency)
  ) as Currency[];
  return valid.length > 0 ? valid : null;
}

export function resolveInitialCurrency(
  currencyParam: string | undefined,
  available: Currency[],
  defaultCurrency: Currency
): Currency {
  if (currencyParam) {
    const normalized = currencyParam.toUpperCase() as Currency;
    if (available.includes(normalized)) return normalized;
  }
  if (available.includes(defaultCurrency)) return defaultCurrency;
  return available[0];
}
